export default __webpack_public_path__ + "assets/daf34be261790efb9aaeec12bcbcd76e.png";